<template>
    <div class="BlockList" v-show="bfloag">
        <div class="BlockList-W">
            <img class="imgs" src="../../../assets/pc/Login/close.png" @click="close"/>
            <div class="blockbox">
                <div class="notehead">
                    <div>Important Notes</div>
                </div>
                <div class="notecontent">
                    <div>
                        <p>
                            Please be advised:
                        </p>
                        <p> This round of fund distribution will be available until <span>December 31, 2025</span>.
                        </p>
                        <p>   If you have not received the <span>USDT (U) transfer</span> within the distribution period, please send your relevant basic information to: <span>serve@faircrypto.fund</span>.
                        </p>
                        <p>   For any subsequent supplementary distributions or future reopening schedules, please refer to the official announcements on the <span>Foundation's website</span>. Stay tuned for updates.
                        </p>
                    </div>
                    </div>
                </div>
                <div class="notefoot">
                    <div>Foundation Management Committee</div>
                    <div>December 31, 2025</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { login } from "@/assets/server/api";
    import { getSubStr, goPAGE } from "@/utils/utils";
    export default {
        props: ["bflog", "rflog"],
        data() {
            return {
                bfloag: false,
            };
        },
        components: {},
        created() {},
        mounted() {},
        watch: {
            deep: true,
            bflog(val) {
                this.bfloag = val;
            },
            rflog(val) {
                this.bfloag = val;
            },
        },
        methods: {
            close() {
                this.bfloag = false;
                this.$emit("bloflog", this.bfloag);
            },
        },
    };
</script>
<style lang="less">
    /deep/.el-message {
    z-index: 99999999999 !important;
    background-color: #fff !important;
    /* 设置文本颜色为白色 */
    color: white !important;
    /* 其他样式调整，根据需要自行添加 */
}
</style>
<style lang="less" scoped>
.BlockList {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999999999999;
    // background: red;
    width: 100%;
    height: 100%;
    overflow: auto;
.BlockList-W {
    max-height: 80vh;
    width: 678px;
    overflow: hidden;
    background: #202020;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    position: absolute;
    z-index: 0 !important;
// border: 1px solid red;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .imgs {
        width: 36px;
        height: 36px;
        margin-right:15px;
        margin-top: 20px;
        cursor: pointer;
        float: right;
        }
        .blockbox {
            width: 600px;
            margin: 5px auto;
            max-height: 60vh;
            /*padding-left: 10px;*/
            overflow-y: auto;
        scroll-behavior: smooth;
        /* 隐藏默认滚动条 */
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE and Edge */
            .notehead{
                text-align: center;
                font-style: normal;
                text-transform: none;
                margin-top: 20px;
                font-weight: 600;
                font-size: 32px;
                color: #FFFFFF;
                line-height: 48px;
            }
            .notecontent{
                font-weight: 400;
                font-size: 26px;
                color: #FFFFFF;
                line-height: 38px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                padding-top: 62px;
                div{
                    margin-left: 20px;
                }
                /*.note{*/
                /*    !*height: 90px;*!*/
                /*}*/
                p{
                   padding: 5px 0;
                    word-wrap:break-word;
                    word-break:break-all;
                }
                span{
                    font-weight: 700;
                    color: #3CF6F0;
                }
                .notetitle{
                    padding: 28px 0;
                    font-size: 36px;
                    font-weight: 600;
                }
                .noteblod{
                    font-weight: 700;
                }
                h2{
                    font-weight: 700;
                    padding: 24px 0;
                    font-size: 32px;
                    line-height: 33px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
            }
            .notefoot{
                margin: 46px auto;
                font-weight: 600;
                font-size: 32px;
                color: #FFFFFF;
                line-height: 48px;
                text-align: right;
                font-style: normal;
                text-transform: none;
                justify-content: flex-end;
            }
        }
    }
/* WebKit内核浏览器：Chrome、Safari、Edge */
::-webkit-scrollbar { /* 滚动条整体宽度/高度 */
    width: 4px; /* 垂直滚动条宽度 */
    height: 4px; /* 水平滚动条高度 */
}

::-webkit-scrollbar-track { /* 轨道样式 */
    background: #f1f1f1;
    border-radius: 5px;
}

::-webkit-scrollbar-thumb { /* 滑块样式 */
    background: #c1c1c1;
    border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover { /* 滑块 hover 状态 */
    background: #a8a8a8;
}

::-webkit-scrollbar-button { /* 轨道按钮（默认隐藏） */
    display: none;
}
::-webkit-scrollbar {
    display: none;
}

::-webkit-scrollbar-corner { /* 边角样式 */
    background: #f1f1f1;
}
}
</style>
